"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var Contact_1 = require("./parts/Contact");
var findErrors_1 = require("lib/functions/findErrors");
var rules = {};
var EmergencyContacts = (function (_super) {
    __extends(EmergencyContacts, _super);
    function EmergencyContacts(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.contacts = [
            {
                id: "contact_1",
                required: true
            },
            {
                id: "contact_2",
                required: false
            }
        ];
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        _this.contacts.forEach(function (e) {
            var rulesForContact = {};
            rulesForContact[e.id + "_name"] = {
                presence: e.required
            };
            rulesForContact[e.id + "_relationship"] = {
                presence: e.required
            };
            rulesForContact[e.id + "_phone"] = {
                presence: e.required
            };
            rules = Object.assign(rules, rulesForContact);
        });
        return _this;
    }
    EmergencyContacts.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    EmergencyContacts.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("validateEmergencyContact", this.isValid);
                return [2];
            });
        });
    };
    EmergencyContacts.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateEmergencyContact");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    EmergencyContacts.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    EmergencyContacts.prototype.isValid = function () {
        console.log("Validate Emergency Contact");
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        return isValid;
    };
    EmergencyContacts.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "EMERGENCY CONTACTS"),
            React.createElement("h3", { className: "sub-title" }, "In the event we are unable to contact you at the phone number you have given please provide two(2) additional contacts"),
            this.contacts.map(function (ed) { return (React.createElement(Contact_1.Contact, { key: ed.id, id: ed.id, required: ed.required, json_data: json_data, onChange: onChange, errors: errors })); })));
    };
    __decorate([
        mobx_1.observable
    ], EmergencyContacts.prototype, "errors", void 0);
    EmergencyContacts = __decorate([
        mobx_react_1.observer
    ], EmergencyContacts);
    return EmergencyContacts;
}(react_1.Component));
exports.EmergencyContacts = EmergencyContacts;
//# sourceMappingURL=data:application/json;base64,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